<template>
    <div>
        <div class="flex justify-around">
            <div class="vx-row">
                <vs-card>
                    <template #title>
                        <h3 class="justify-around flex">Please log in</h3>
                    </template>
                    <template #text>
                        <div class="p-6">
                            <vs-input label="Username" class="mt-6" v-model="loginObject.username" @keyup.enter="login">
                                <template #icon>
                                    <font-awesome-icon icon="user"/>
                                </template>
                            </vs-input>
                            <vs-input label="Password" type="password" class="mt-6" v-model="loginObject.password" @keyup.enter="login">
                                <template #icon>
                                    <font-awesome-icon icon="key"/>
                                </template>
                            </vs-input>

                            <vs-button class="mt-6" color="success" @click="login">Log in</vs-button>
                        </div>
                    </template>
                </vs-card>
            </div>
        </div>
    </div>
</template>
<script>

    export default {
        data() {
            return {
                loginObject: {
                    username: '',
                    password: ''
                }
            }
        },
        methods: {
            login() {
                const loading = this.$vs.loading()
                const thisIns = this
                this.$http.post('/login', this.loginObject)
                    .then(function(response) {
                        thisIns.$store.commit('setAuthToken', response.data)
                        thisIns.$router.push('/')
                    }).catch(function() {
                        thisIns.$printError('Login failed')
                    }).finally(function() {
                        loading.close()
                    })
            }
        }
    }
</script>
